/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationStepsControllerCreateNotificationMutationRequest, WorkflowApplicationStepsControllerCreateNotificationMutationResponse, WorkflowApplicationStepsControllerCreateNotificationPathParams } from "../../models/workflowsController/WorkflowApplicationStepsControllerCreateNotification";

function getWorkflowApplicationStepsControllerCreateNotificationUrl(id: WorkflowApplicationStepsControllerCreateNotificationPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/workflow-application-steps/${id}/notifications` as const }  
  return res
}

/**
 * @summary Notify the active step's current owner(s) (reminder / poke)
 * {@link /api/v1/workflow-application-steps/:id/notifications}
 */
export async function workflowApplicationStepsControllerCreateNotification(id: WorkflowApplicationStepsControllerCreateNotificationPathParams["id"], data?: WorkflowApplicationStepsControllerCreateNotificationMutationRequest, config: Partial<RequestConfig<WorkflowApplicationStepsControllerCreateNotificationMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowApplicationStepsControllerCreateNotificationMutationResponse, ResponseErrorConfig<Error>, WorkflowApplicationStepsControllerCreateNotificationMutationRequest>({ method : "POST", url : getWorkflowApplicationStepsControllerCreateNotificationUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}